import { render, staticRenderFns } from "./StudioTestimonialPreview.vue?vue&type=template&id=e2704b4c&scoped=true&"
import script from "./StudioTestimonialPreview.vue?vue&type=script&lang=js&"
export * from "./StudioTestimonialPreview.vue?vue&type=script&lang=js&"
import style0 from "./StudioTestimonialPreview.vue?vue&type=style&index=0&id=e2704b4c&lang=scss&scoped=true&"
import style1 from "./StudioTestimonialPreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2704b4c",
  null
  
)

export default component.exports